// skills/woodworking/woodworkingData.js
// Woodworking products and tool configuration

// Arrow shafts from logs
export const SHAFT_RECIPES = {
    NORMAL: {
        id: 'arrow_shafts',
        name: 'Arrow Shafts',
        level: 1,
        xp: 5,
        baseTime: 2000,
        inputItem: 'common_timber',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 15 }
        ],
        color: '#8B4513'
    },
    IRONWOOD: {
        id: 'ironwood_arrow_shafts',
        name: 'Ironwood Arrow Shafts',
        level: 15,
        xp: 10,
        baseTime: 2500,
        inputItem: 'ironwood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 30 }
        ],
        color: '#A0522D'
    },
    SOFTBARK: {
        id: 'softbark_arrow_shafts',
        name: 'Softbark Arrow Shafts',
        level: 35,
        xp: 16.7,
        baseTime: 3000,
        inputItem: 'softbark_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 45 }
        ],
        color: '#6B8E23'
    },
    GOLDLEAF: {
        id: 'goldleaf_arrow_shafts',
        name: 'Goldleaf Arrow Shafts',
        level: 50,
        xp: 25,
        baseTime: 3500,
        inputItem: 'goldleaf_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 60 }
        ],
        color: '#D2691E'
    },
    REDGRAIN: {
        id: 'redgrain_arrow_shafts',
        name: 'Redgrain Arrow Shafts',
        level: 65,
        xp: 30,
        baseTime: 3750,
        inputItem: 'redgrain_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 68 }
        ],
        color: '#d2691e'
    },
    GRAVEWOOD: {
        id: 'gravewood_arrow_shafts',
        name: 'Gravewood Arrow Shafts',
        level: 80,
        xp: 37,
        baseTime: 4250,
        inputItem: 'gravewood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 80 }
        ],
        color: '#228b22'
    },
    ARCANEWOOD: {
        id: 'arcanewood_arrow_shafts',
        name: 'Arcanewood Arrow Shafts',
        level: 95,
        xp: 50,
        baseTime: 5000,
        inputItem: 'arcanewood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arrow_shafts', weight: 1, quantity: 95 }
        ],
        color: '#9932CC'
    }
};

// Arrows from shafts + arrowheads
export const ARROW_RECIPES = {
    PYRESTONE: {
        id: 'pyrestone_arrows',
        name: 'Pyrestone Arrows',
        level: 1,
        xp: 10,
        baseTime: 2000,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'pyrestone_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'pyrestone_arrows', weight: 1, quantity: 15 }
        ],
        color: '#b87333'
    },
    PALE_SHARD: {
        id: 'pale_shard_arrows',
        name: 'Pale Shard Arrows',
        level: 15,
        xp: 20,
        baseTime: 2500,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'pale_shard_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'pale_shard_arrows', weight: 1, quantity: 15 }
        ],
        color: '#c0c0c0'
    },
    BLACKIRON: {
        id: 'blackiron_arrows',
        name: 'Blackiron Arrows',
        level: 30,
        xp: 32,
        baseTime: 3000,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'blackiron_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'blackiron_arrows', weight: 1, quantity: 15 }
        ],
        color: '#696969'
    },
    SKYIRON: {
        id: 'skyiron_arrows',
        name: 'Skyiron Arrows',
        level: 45,
        xp: 46,
        baseTime: 3500,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'skyiron_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'skyiron_arrows', weight: 1, quantity: 15 }
        ],
        color: '#4169e1'
    },
    VERDANT_CORE: {
        id: 'verdant_core_arrows',
        name: 'Verdant Core Arrows',
        level: 60,
        xp: 62,
        baseTime: 4000,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'verdant_core_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'verdant_core_arrows', weight: 1, quantity: 15 }
        ],
        color: '#228b22'
    },
    VOIDSTEEL: {
        id: 'voidsteel_arrows',
        name: 'Voidsteel Arrows',
        level: 75,
        xp: 80,
        baseTime: 4500,
        inputItems: [
            { itemId: 'arrow_shafts', quantity: 15 },
            { itemId: 'voidsteel_arrowheads', quantity: 15 },
            { itemId: 'feathers', quantity: 15 }
        ],
        drops: [
            { itemId: 'voidsteel_arrows', weight: 1, quantity: 15 }
        ],
        color: '#00ced1'
    }
};

// Bows from logs (scaled to max level 75)
export const BOW_RECIPES = {
    SHORTBOW: {
        id: 'shortbow',
        name: 'Shortbow',
        level: 5,
        xp: 8,
        baseTime: 3000,
        inputItem: 'common_timber',
        inputQuantity: 1,
        drops: [
            { itemId: 'shortbow', weight: 1, quantity: 1 }
        ],
        color: '#8B4513'
    },
    IRONWOOD_SHORTBOW: {
        id: 'ironwood_shortbow',
        name: 'Ironwood Shortbow',
        level: 15,
        xp: 20,
        baseTime: 3500,
        inputItem: 'ironwood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'ironwood_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#A0522D'
    },
    SOFTBARK_SHORTBOW: {
        id: 'softbark_shortbow',
        name: 'Softbark Shortbow',
        level: 30,
        xp: 40,
        baseTime: 4000,
        inputItem: 'softbark_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'softbark_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#6B8E23'
    },
    GOLDLEAF_SHORTBOW: {
        id: 'goldleaf_shortbow',
        name: 'Goldleaf Shortbow',
        level: 45,
        xp: 60,
        baseTime: 4500,
        inputItem: 'goldleaf_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'goldleaf_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#D2691E'
    },
    REDGRAIN_SHORTBOW: {
        id: 'redgrain_shortbow',
        name: 'Redgrain Shortbow',
        level: 55,
        xp: 75,
        baseTime: 5000,
        inputItem: 'redgrain_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'redgrain_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#d2691e'
    },
    GRAVEWOOD_SHORTBOW: {
        id: 'gravewood_shortbow',
        name: 'Gravewood Shortbow',
        level: 65,
        xp: 90,
        baseTime: 5500,
        inputItem: 'gravewood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'gravewood_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#228b22'
    },
    ARCANEWOOD_SHORTBOW: {
        id: 'arcanewood_shortbow',
        name: 'Arcanewood Shortbow',
        level: 75,
        xp: 110,
        baseTime: 6000,
        inputItem: 'arcanewood_logs',
        inputQuantity: 1,
        drops: [
            { itemId: 'arcanewood_shortbow', weight: 1, quantity: 1 }
        ],
        color: '#9932CC'
    }
};

// Staffs from logs + glyph cores (assembled in woodworking)
export const STAFF_RECIPES = {
    COMMON: {
        id: 'common_staff',
        name: 'Common Staff',
        level: 10,
        xp: 20,
        baseTime: 3000,
        inputItems: [
            { itemId: 'common_timber', quantity: 2 },
            { itemId: 'common_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'common_staff', weight: 1, quantity: 1 }
        ],
        color: '#DEB887'
    },
    IRONWOOD: {
        id: 'ironwood_staff',
        name: 'Ironwood Staff',
        level: 20,
        xp: 35,
        baseTime: 3500,
        inputItems: [
            { itemId: 'ironwood_logs', quantity: 2 },
            { itemId: 'ironwood_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'ironwood_staff', weight: 1, quantity: 1 }
        ],
        color: '#A0522D'
    },
    SOFTBARK: {
        id: 'softbark_staff',
        name: 'Softbark Staff',
        level: 35,
        xp: 55,
        baseTime: 4000,
        inputItems: [
            { itemId: 'softbark_logs', quantity: 2 },
            { itemId: 'softbark_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'softbark_staff', weight: 1, quantity: 1 }
        ],
        color: '#6B8E23'
    },
    GOLDLEAF: {
        id: 'goldleaf_staff',
        name: 'Goldleaf Staff',
        level: 50,
        xp: 75,
        baseTime: 4500,
        inputItems: [
            { itemId: 'goldleaf_logs', quantity: 2 },
            { itemId: 'goldleaf_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'goldleaf_staff', weight: 1, quantity: 1 }
        ],
        color: '#D2691E'
    },
    REDGRAIN: {
        id: 'redgrain_staff',
        name: 'Redgrain Staff',
        level: 60,
        xp: 90,
        baseTime: 5000,
        inputItems: [
            { itemId: 'redgrain_logs', quantity: 2 },
            { itemId: 'redgrain_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'redgrain_staff', weight: 1, quantity: 1 }
        ],
        color: '#CD853F'
    },
    GRAVEWOOD: {
        id: 'gravewood_staff',
        name: 'Gravewood Staff',
        level: 75,
        xp: 110,
        baseTime: 5500,
        inputItems: [
            { itemId: 'gravewood_logs', quantity: 2 },
            { itemId: 'gravewood_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'gravewood_staff', weight: 1, quantity: 1 }
        ],
        color: '#228B22'
    },
    ARCANEWOOD: {
        id: 'arcanewood_staff',
        name: 'Arcanewood Staff',
        level: 90,
        xp: 135,
        baseTime: 6000,
        inputItems: [
            { itemId: 'arcanewood_logs', quantity: 2 },
            { itemId: 'arcanewood_glyph_core', quantity: 1 }
        ],
        drops: [
            { itemId: 'arcanewood_staff', weight: 1, quantity: 1 }
        ],
        color: '#9370DB'
    }
};

// Woodworking knives (tools)
export const TOOLS = {
    PYRESTONE: {
        id: 'pyrestone_knife',
        name: 'Pyrestone Knife',
        level: 1,
        speedMultiplier: 1.0,
        price: 0
    },
    BLACKIRON: {
        id: 'blackiron_knife',
        name: 'Blackiron Knife',
        level: 15,
        speedMultiplier: 1.2,
        price: 1000
    },
    PALE_SHARD: {
        id: 'pale_shard_knife',
        name: 'Pale Shard Knife',
        level: 30,
        speedMultiplier: 1.4,
        price: 5000
    },
    SKYIRON: {
        id: 'skyiron_knife',
        name: 'Skyiron Knife',
        level: 45,
        speedMultiplier: 1.6,
        price: 25000
    },
    VERDANT: {
        id: 'verdant_knife',
        name: 'Verdant Knife',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VOIDSTEEL: {
        id: 'voidsteel_knife',
        name: 'Voidsteel Knife',
        level: 80,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    SHAFT_RECIPES,
    ARROW_RECIPES,
    BOW_RECIPES,
    STAFF_RECIPES,
    TOOLS
};
